import React from 'react';
import { withTranslation } from 'react-i18next';

import Layout from '../Layout';

const Success = withTranslation()(({ t }) => {
  return (
    <div className="wrapper ula success">
      <Layout cover={{ src: '/images/cover-main.png' }}>
        <div className="wrapper-shrink">
          <img src="/images/ULA/Success.svg" alt="success" />
          <div className="title">
            <strong>{t('Sign out complete.')}</strong>
          </div>
          <div className="description">{t('You are now signed out of all Chaos products licensed to you')}</div>
          <strong>{t('You may now close this window.')}</strong>
        </div>
      </Layout>
    </div>
  );
});

export default Success;
